import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { EventsService } from 'src/app/services/event/event.service';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { ProgressingComponent } from '../progressing/progressing.component';

@Component({
	selector: 'app-boyd-rewards-card',
	templateUrl: './boyd-rewards-card.component.html',
	styleUrls: ['./boyd-rewards-card.component.scss'],
})

export class BoydRewardsCardComponent implements OnInit {

	public isCardConnected: boolean;
	public boydCardImage: string;
	public connectedCardImg: string;
	public loading: any;
	public isAuthenticated: boolean = false;
	public tierLevel: any;
	public connectedCardImgCheckmark: string;

	@ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

	constructor(
		private utils: UtilsService,
		private boydRewardsService: BoydRewardsService,
		private navigator: Navigator,
		private menuStateService: MenuStateService,
		private userSessionService: UserSessionService,
		private eventsService: EventsService,
		public loadingController: LoadingController
	) { }

	ngOnInit(): void {

		this.checkIfAuthenticated();

		this.setDefaultCardImages();
		this.eventsService.subscribe('menuopen', () => {
			this.checkCardTier();
			this.checkIfAuthenticated();
		})
	}

	private checkIfAuthenticated(): void {
		if (!this.userSessionService.isAuthenticated()) return;

		this.boydRewardsService.checkConnectionToBoydCard().subscribe((isConnected: boolean) => {
			this.isCardConnected = !!isConnected;
		});
	}

	private checkCardTier() {
		this.userSessionService.getCustomer().pipe(take(2)).subscribe(res => {
			if (res?.customerId) {
				this.isAuthenticated = true;
				const apiCall$ = this.boydRewardsService.callGetExternalPointsInfo();
				this.progressingUI.listenObservable(apiCall$);

				apiCall$.subscribe(res => {
					this.tierLevel = res.payload.tierLevel;
					let imgNameCheckmark = "boydcustom-feedbackmark" + this.tierLevel + ".png";
					let imgName = "boydcard-" + this.tierLevel + ".png";
					if (this.tierLevel) {
						this.connectedCardImgCheckmark = this.utils.getCDNAsset("imgs/" + imgNameCheckmark);
						this.connectedCardImg = this.utils.getCDNAsset("imgs/" + imgName);
					} else {
						this.connectedCardImgCheckmark = this.utils.getCDNAsset("imgs/default-boyd-card.png");
						this.connectedCardImg = this.utils.getCDNAsset("imgs/default-boyd-card.png");
					}
				})
			}
		});
	}

	async showLoading() {
		this.loading = await this.loadingController.create({
			message: 'Loading...',
			duration: 3000
		});

		this.loading.present();
	}

	private setDefaultCardImages() {
		this.connectedCardImgCheckmark = this.utils.getCDNAsset("imgs/default-boyd-card.png");
		this.connectedCardImg = this.utils.getCDNAsset("imgs/default-boyd-card.png");
	}

	public changeBoydCardtext() {
		if (this.isCardConnected) {
			this.boydCardImage = this.utils.getCDNAsset('icon/card-connected.svg');
		} else {
			this.boydCardImage = this.utils.getCDNAsset('icon/card-not-connected.svg');
		}
	}

	public connectBoydCard() {
		this.menuStateService.closeMenu('main-menu');
		if (this.isCardConnected) {
			this.navigator.navigateTo("BoydMyBalanceComponent", {}, {}, 'main-menu');
		} else {
			this.navigator.navigateTo("EnrollBoydRewardsComponent", {}, {}, 'main-menu');
		}
	}

}
